const supportedLanguageCodes = [
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'et',
    'fi',
    'fr',
    'hr',
    'hu',
    'it',
    'lt',
    'lv',
    'nb',
    'nl',
    'pl',
    'pt',
    'ro',
    'sk',
    'sv',
    'sl',
];

export const localeToLang = (locale: string) => {
    const localeFromParamOrBrowser = locale ? locale : navigator.language;
    const localeArray = localeFromParamOrBrowser.split('-');
    if (localeArray.length < 1) {
        return 'en';
    }
    const languageCode = supportedLanguageCodes.find((country) => country === localeArray[0]);

    return languageCode ? languageCode : 'en';
};
